import type React from 'react'
import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type {
  TooltipMargin,
  TooltipPadding,
  TooltipPosition,
} from './Tooltip.h'

import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { COLOR, CORNERS } from 'vars/index'
import { TooltipArrowAlign, TooltipMargins, TooltipPaddings } from './Tooltip.h'
import { TooltipSC, TooltipTitle } from './Tooltip.styled'

export interface ITooltip {
  children: React.ReactNode
  backgroundColorDefault?: COLOR
  corners?: CORNERS
  position?: TooltipPosition
  arrow?: boolean
  arrowWidth?: string
  arrowAlign?: TooltipArrowAlign
  title?: ITextBoxProps['title']
  font?: ITextBoxProps['font']
  maxLines?: ITextBoxProps['maxLines']
  colorText?: ITextBoxProps['color']
  paddings?: TooltipPadding
  margins?: TooltipMargin
  isVisible?: boolean
}

export const Tooltip = ({
  children,
  corners = CORNERS.CORNERS_10,
  backgroundColorDefault = COLOR.SURFACE_DARK_7,
  position,
  arrow = true,
  arrowWidth = '6px',
  arrowAlign = TooltipArrowAlign.TopLeft,
  title,
  font = TextBoxTypes.Caption4,
  maxLines = 1,
  colorText = TextBoxColors.TEXT_ICON_PRIMARY,
  paddings = TooltipPaddings.SIZE_10,
  margins = TooltipMargins.SIZE_10,
  isVisible,
}: ITooltip): JSX.Element => {
  return (
    <TooltipSC
      corners={corners}
      backgroundColorDefault={backgroundColorDefault}
      position={position}
      arrow={arrow}
      arrowWidth={arrowWidth}
      arrowAlign={arrowAlign}
      paddings={paddings}
      margins={margins}
      isVisible={isVisible}
    >
      {children}
      {title && (
        <TooltipTitle>
          <TextBox
            title={title}
            font={font}
            maxLines={maxLines}
            color={colorText}
          />
        </TooltipTitle>
      )}
    </TooltipSC>
  )
}
